import { User } from "@/gql/graphql";
import * as amplitude from "@amplitude/analytics-browser";
import { EventOptions } from "@amplitude/analytics-types";
import LocalStorageService, { LocalStorageKey } from "../LocalStorageService";
import { AnalyticEvent, AnalyticEventType } from "./Events";

export default class AnalyticsService {
  static async trackLogInSuccess(user: User) {
    amplitude.setUserId(user.id);
    const userIdentify = new amplitude.Identify();
    userIdentify.set("id", user.id);
    userIdentify.set("email", user.email);
    userIdentify.set("name", user.name);
    userIdentify.set("role", user.role);
    userIdentify.set("status", user.status);
    amplitude.identify(userIdentify);
    this.track(AnalyticEventType.LogInSuccess, {});
    LocalStorageService.setItem(LocalStorageKey.user_id, user.id);
  }

  static async trackLogOutSuccess() {
    const userId = LocalStorageService.getItem(LocalStorageKey.user_id);
    const options = userId ? { user_id: userId } : undefined;
    await this.track(AnalyticEventType.LogOutSuccess, {}, options);
    LocalStorageService.removeItem(LocalStorageKey.user_id);
    amplitude.reset();
    amplitude.flush();
  }

  static track<T extends AnalyticEventType>(
    event: T,
    data: AnalyticEvent[T],
    options?: EventOptions,
  ) {
    return amplitude.track(event, data, options).promise;
  }
}
